import { component } from 'picoapp'

class HashScroll {

  constructor(node, ctx) {
    // selectors
    this._node = node;
    this._active = true;

    if (window.location.hash) {
      let hid = window.location.hash.split('?')[0].replace(/#/gi, ''),
          el = this._node.querySelector(`#${hid}`);

      if (el) {
        setTimeout(() => {
          let destination = el.offsetTop,
              offset = window.innerWidth >= 768 ? 124 : 80;

          if (this._active) {
            window.scrollTo({
              top: destination + offset,
              left: 0,
              behavior: "smooth",
            });
          }
        }, 333);
      }
    }

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Unmount.
  //
  unmount() {
    this._active = false;
  }
}

export default component((node, ctx) => new HashScroll(node, ctx))
